import { createTheme } from '@mui/material/styles';

export const mojTheme = createTheme({
  palette: {
    primary: {
      main: '#4caf50',
      light: '#f0f9ee',
      dark: '#006400',
    },
    secondary: {
      main: '#fbe122',
      light: '#FFFEF7',
    },
    background: {
      default: '#FFFEF7',
      paper: '#FFFEF7',
    },
    star: {
      empty: '#D1D5DB',
      filled: '#e6d130',
    },
    text: {
      primary: '#000000',
      secondary: '#008000',
      disabled: 'grey',
    },
    warning: {
      main: '#ffff00',
    },
    action: {
      disabled: '#9e9e9e',
    },
  },
  typography: {
    fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
    h1: {
      fontSize: '2.25rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
      color: '#43b02a',
      textAlign: 'center',
    },
    h2: {
      fontSize: '1.875rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 700,
      marginBottom: '1rem',
      color: '#43b02a',
    },
    h4: {
      fontSize: '1rem',
      fontWeight: 'bold',
      color: '#000000',
      textAlign: 'left',
      marginTop: '1em',
      marginBottom: '1em',
    },
    h6: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#000000',
    },
    caption: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#008000',
      textAlign: 'left',
    },

    body1: {
      fontSize: '0.8rem',
      color: '#000000',
      arrowIconColor: '#000', //for arrow in button
      priceQuoteBackground: '#f0f9ee',
      ndrpSectionBackground: '#f9fafa',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#FBE122',
          '&:hover': {
            backgroundColor: '#FBE122',
          },
          color: '#000000',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          color: 'rgb(55 65 81)',
          fill: '#43b02a',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          color: '#4caf50',
          '&:hover': {
            color: '#4caf50',
          },
          width: '1.5rem',
          height: '1.5rem',
          '&.Mui-disabled': {
            color: '#9e9e9e',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          color: 'rgb(17 24 39)',
          fontSize: '1rem',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
        },
      },
    },
  },
});
